import { useState, type ChangeEvent, type KeyboardEvent } from "react";

type Props = {
  onSubmit: (pin: string) => void;
  length?: number; // default 4
  error?: string | null;
  busy?: boolean;
};

// Single numeric input. Underneath the hood it's a regular text input with
// inputMode=numeric — works on mobile keyboards, easy to test, no per-digit
// auto-advance complexity. Swap for a 4-box grid later if UX wants it.
export function PinPad({ onSubmit, length = 4, error, busy }: Props) {
  const [pin, setPin] = useState("");
  const canSubmit = pin.length === length && !busy;

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const filtered = e.target.value.replace(/\D/g, "").slice(0, length);
    setPin(filtered);
  };

  const submit = () => {
    if (canSubmit) onSubmit(pin);
  };

  const onKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") submit();
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium" htmlFor="pin-input">PIN</label>
      <input
        id="pin-input"
        autoFocus
        type="password"
        inputMode="numeric"
        autoComplete="off"
        maxLength={length}
        value={pin}
        onChange={onChange}
        onKeyDown={onKey}
        disabled={busy}
        className="w-full rounded-md border bg-surface px-3 py-2 text-center text-2xl tracking-[0.5em] focus:outline-none focus:ring-2"
      />
      {error ? <p className="text-sm text-danger-text">{error}</p> : null}
      <button
        type="button"
        className="w-full rounded-md bg-brand px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
        disabled={!canSubmit}
        onClick={submit}
      >
        {busy ? "Đang xử lý..." : "Đăng nhập"}
      </button>
    </div>
  );
}
